import { render, staticRenderFns } from "./select-element.vue?vue&type=template&id=1f126908&scoped=true"
import script from "./select-element.vue?vue&type=script&lang=js"
export * from "./select-element.vue?vue&type=script&lang=js"
import style0 from "./select-element.vue?vue&type=style&index=0&id=1f126908&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f126908",
  null
  
)

export default component.exports